import React from 'react';
import { useTrack } from './useTrack';

interface TrackClickProps {
  tip: string;
  children: React.ReactNode;
}

function TrackClick({ tip, children }: TrackClickProps) {
  const track = useTrack();
  if (React.isValidElement(children)) {
    const { onClick } = children.props;
    return React.cloneElement(children, {
      onClick: (event: any) => {
        track('click', {
          tip,
        });
        onClick && onClick(event);
      },
    });
  }
  return <>{children}</>;
}

export default TrackClick;
